module.exports = __webpack_public_path__ + "media/webfonts/fa-solid-900-d745348d.woff";